module.exports = __webpack_public_path__ + "img/img_head_luckybot_logo@2x.b251d3ad.png";